import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { Link } from 'react-router-dom';
import { PATIENT, RISK_POT_REPORT } from '../../../utils/RouteConstants';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { IRiskPotReportPreAssessment } from '../../../models/IRiskPotReport';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IRiskPotReportPreAssessmentSearchTable {
    preAssessments: IRiskPotReportPreAssessment[];
}

export const RiskPotReportPreAssessmentSearchTable: React.FunctionComponent<IRiskPotReportPreAssessmentSearchTable> = ({ preAssessments }) => {

    const renderTableLink = (preAssessment: IRiskPotReportPreAssessment, linkText?: string) => {
        return <Link to={`${PATIENT}/${preAssessment.patient?.patientGuidId}/${RISK_POT_REPORT}/${preAssessment.riskPotReportId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <SortableTableHeader propertyToSortBy="RegDate" headerText="Datum" />
                    <SortableTableHeader propertyToSortBy="RiskPotReport.RiskPotReportNumber" headerText="Ärendenummer" />
                    <SortableTableHeader propertyToSortBy="RiskPotReport.Patient.PersonalSecurityId" headerText="Personnummer" />
                    <th>Organisationsnummer</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {
                    preAssessments.length > 0 ?
                        preAssessments.map((preAssessment, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(preAssessment, dateTimeToDateString(preAssessment.createdDate))}</td>
                                <td className="table-data-link">{renderTableLink(preAssessment, preAssessment.riskPotReportNumber)}</td>
                                <td className="table-data-link">{renderTableLink(preAssessment, formatPersonalSecurityNumberAndOrganisationNumber(preAssessment.patient?.personalSecurityNumber))}</td>
                                <td className="table-data-link">{renderTableLink(preAssessment, formatPersonalSecurityNumberAndOrganisationNumber(preAssessment.careProvider?.orgNum))}</td>
                                <td className="table-data-link">{renderTableLink(preAssessment, preAssessment.status)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={5}>Hittade inga förhandsbedömningar</td></tr>
                }
            </tbody>
        </Table>
    )
}